/**
 * CactusIllustration/index.js
 * desc: cactus svg illustration
 * note: stateless presentational component
 */
'use strict';

import { classNames } from '../../../utilities';


const CactusIllustration = ({ className }) => {
    const classList = classNames('cactus illustration', className);

    return (
        <figure className={ classList } > 
            <svg viewBox="0 0 104 184" xmlns="http://www.w3.org/2000/svg"><path d="M92.828 27.351c-6.282 0-11.456 5.2-11.456 11.68v43.174c0 6.706-4.139 12.658-8.869 12.658h-8.869v-77.91c0-6.404-5.1-11.679-11.455-11.679-6.282 0-11.456 5.2-11.456 11.68v18.912h-8.869c-4.656 0-8.869-3.014-8.869-6.254V11.679C22.985 5.274 17.885 0 11.53 0 5.247 0 .074 5.199.074 11.679v17.933c0 16.275 14.264 29.536 31.706 29.536h8.87v53.196h-8.87c-4.656 0-8.869-3.014-8.869-6.254V88.157c0-6.404-5.1-11.679-11.455-11.679C5.174 76.478 0 81.678 0 88.158v17.932c0 16.275 14.264 29.536 31.706 29.536h8.87v46.641c0 .979.738 1.733 1.699 1.733h19.438c.96 0 1.7-.754 1.7-1.733V118.07h8.868c17.517 0 31.707-16.124 31.707-35.94V38.954c.295-6.33-4.804-11.604-11.16-11.604z"/></svg>
        </figure>
    );
};


export default CactusIllustration;
